<template>
  <div id="login-page">
    <div class="login-container">
      <div class="logo-container">
        <img src="https://sander-gruppe.eu/wp-content/uploads/2019/07/ms-logo.png" alt="Ihr Logo" class="logo">
      </div>
      <div class="reset-wrapper">
        <h3>Neues Passwort für Ihren Benutzer</h3>
        <form @submit.prevent="submit">
          <div class="input-container">
            <label>Neues Passwort</label>
            <input v-model.trim="password" type="password" required />
          </div>
          <div class="input-container">
            <label>Passwort bestätigen</label>
            <input v-model.trim="passwordConfirmation" type="password" required />
          </div>
          <div v-if="error" class="error-message">{{ error }}</div>
          <div v-if="success" class="success-message">Passwort gespeichert. Du kannst dich jetzt einloggen.</div>
          <button :disabled="loading" type="submit">{{ loading ? 'Speichere…' : 'Passwort speichern' }}</button>
        </form>
      </div>
      <LegalFooter :show-protected-links="false" :show-feedback-button="false" />
    </div>
  </div>
</template>

<script>
import api from '@/api/client';
import LegalFooter from './LegalFooter.vue';

export default {
  name: 'ResetPassword',
  components: {
    LegalFooter,
  },
  data() {
    const qp = new URLSearchParams(window.location.search);
    return {
      email: qp.get('email') || '',
      kdnr: qp.get('kdnr') || '',
      token: qp.get('token') || '',
      password: '',
      passwordConfirmation: '',
      loading: false,
      error: '',
      success: false,
    };
  },
  methods: {
    getAppHomePath() {
      const normalizedPath = (window.location.pathname || '/').replace(/\/+$/, '');
      if (!normalizedPath || normalizedPath === '/reset-password') {
        return '/';
      }

      return normalizedPath.endsWith('/reset-password')
        ? `${normalizedPath.slice(0, -'/reset-password'.length) || ''}/`
        : '/';
    },
    async submit() {
      this.error = '';
      this.success = false;
      if (this.password !== this.passwordConfirmation) {
        this.error = 'Passwörter stimmen nicht überein.';
        return;
      }
      this.loading = true;
      try {
        await api.post('/api/shopusers/password/reset', {
          email: this.email,
          kdnr: this.kdnr,
          token: this.token,
          password: this.password,
          password_confirmation: this.passwordConfirmation,
        });
        this.success = true;
        setTimeout(() => { window.location.href = this.getAppHomePath(); }, 1200);
      } catch (err) {
        this.error = err?.response?.data?.message || 'Speichern fehlgeschlagen.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>

.reset-wrapper {
  max-width: 720px;
  margin: 60px auto;
  padding: 48px 56px;
  border-radius: 16px;
  background: #fff;
  /* box-shadow: 0 18px 48px rgba(0,0,0,0.08); */
  text-align: left;
}
h3 {
  font-size: 20px;
  font-weight: 700;
  color: #4f4e4ebc;
  margin-bottom: 26px;
}
.input-container { margin-bottom: 18px; }
.input-container label { display:block; margin-bottom:8px; color:#555; font-weight:500; }
.input-container input {
  width:100%;
  padding: 12px 14px;
  border:1px solid #d6d6d6;
  border-radius: 10px;
  font-size: 15px;
}
.input-container input {
  width: 96%;
}
button {
  width:100%;
  padding:14px;
  border: none;
  border-radius:10px;
  background:rgba(0, 0, 0, 0);
  border: 1px solid rgb(116, 116, 116);
  color:rgb(116, 116, 116);
  font-weight:500;
  cursor:pointer;
  margin-top: 6px;
  color: #747474;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}
button:not(:disabled):hover {
  border-color: #747474;
  background-color: #f6f6f6;
  color: #333333;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
button:disabled { opacity:0.6; cursor: default; }
.error-message { color:#b91c1c; margin-bottom:10px; }
.success-message { color:#15803d; margin-bottom:10px; }


#login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #F5F5F5;
}
.login-container {
  background: #FFFFFF;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 50rem;
}
.logo-container {
  text-align: left;
  margin-bottom: 1rem;
}
.logo {
  max-width: 100%;
  height: 5em;
}
.footer {
  margin-top: 40px;
}
.footer-first-row {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-bottom: 20px;
}
.footer-first-row a,
.footer-second-row a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.footer-first-row img {
  max-width: 1.5rem;
}
.footer-second-row img {
  max-width: 3.5rem;
}
</style>
